define.alias("shared/utils/uuid", "preview-grid/utils/uuid");